import React, { createContext, useContext, useState, useEffect } from 'react';
import { onAuthStateChanged, signInWithPopup, signInWithRedirect, signOut } from 'firebase/auth';
import { ref, get } from 'firebase/database';
import { auth, googleProvider, database } from '../firebase';

const AuthContext = createContext(null);

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) throw new Error('useAuth must be used within AuthProvider');
  return context;
};

export default function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [isCurator, setIsCurator] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (firebaseUser) => {
      setUser(firebaseUser);
      if (firebaseUser) {
        try {
          const snap = await get(ref(database, `curators/${firebaseUser.uid}`));
          setIsCurator(snap.val() === true);
        } catch {
          setIsCurator(false);
        }
      } else {
        setIsCurator(false);
      }
      setLoading(false);
    });
    return unsubscribe;
  }, []);

  const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
  const signIn = () => isMobile
    ? signInWithRedirect(auth, googleProvider)
    : signInWithPopup(auth, googleProvider);
  const logOut = () => signOut(auth);

  return (
    <AuthContext.Provider value={{ user, isCurator, loading, signIn, logOut }}>
      {children}
    </AuthContext.Provider>
  );
}
